{
  "clear": "Temizle",
  "invalid": "(geçersiz)",
  "loading": "Yükleniyor...",
  "noResults": "Sonuç yok",
  "valid": "(geçerli)"
}
